import React from 'react'
import ProductStore from '../../../stores/product-store'
import ImagePreview from '../../utils/order-image-preview'
import OpeLoader from '../../utils/ope-loader'
import createReactClass from 'create-react-class'


var ThumbWrapper = createReactClass({

    mounted: false,

	getInitialState: function () {
		return {
			maxWidth: 80,
			maxHeight: 80
		};
	},
	componentDidMount: function () {
        this.mounted = true;
		this._handleResize();
		window.addEventListener('resize', this._handleResize, false);
	},
	_handleResize: function () {
		if (window.innerWidth <= 640) {
			if (this.mounted) {
				this.setState({maxWidth: 120, maxHeight: 120});
			}
		} else {
			if (this.mounted) {
				this.setState({maxWidth: 80, maxHeight: 80});
			}
		}
	},

	render: function() {
		//@TODO move this to a util function to be used by this, detailed.js and possibly the upsale thumb
		var productOptions = ProductStore.getProductById(this.props.item.productId).options,
			item = this.props.item,
			itemPosition = item.options.position,
			imageX = (itemPosition.percentageX * 100).toFixed(8) / item.options.scale,
			imageY = (itemPosition.percentageY * 100).toFixed(8) / item.options.scale,
			productAspect = this.props.productAspect,
			imageAspect = this.props.imageAspect,
			imageFilter = item.options.imageFilter,
			thumbStyle = {
				width: this.state.maxWidth,
				height: this.state.maxHeight
			},
			imageStyle = {
				width: this.state.maxWidth,
				height: this.state.maxHeight,
				cursor: 'pointer',
				transform: 'scale(' + item.options.scale + ') translate3d(' +
					imageX + '%, ' + imageY + '%, 0)'
			};

		if(this.props.image) {
			var imageWidth = this.props.image.getWidth();
			var imageHeight = this.props.image.getHeight();
			var angle = 0;
			if(typeof imageFilter.rotate !== 'undefined') {
			 	if(typeof imageFilter.rotate.angle !== 'undefined') {
			 		angle = imageFilter.rotate.angle;
			 	}
			}

			//If the image is rotated in such a way that we need to switch the height and width
			if(angle == 90 || angle == 270 || angle == -90 || angle == -270) {
				var tmp = imageHeight;
				imageHeight = imageWidth;
				imageWidth = tmp;
			}
		}

		// If the product is in "landscape" mode
		if(productAspect > 1 && !item.isPortrait) {
			thumbStyle.width = this.state.maxWidth;
			thumbStyle.height = this.state.maxHeight / productAspect;
		}

		// If the product is in "landscape" mode
		if(productAspect > 1 && item.isPortrait) {
			thumbStyle.width = this.state.maxWidth / productAspect;
			thumbStyle.height = this.state.maxHeight;
		}

		if(imageWidth) {
			var imageRatio = imageWidth / imageHeight,
				widthRatio = thumbStyle.width / imageWidth,
				heightRatio = thumbStyle.height / imageHeight,
				newImageHeight = 0, newImageWidth = 0;

			if(heightRatio > widthRatio) {
				newImageHeight = imageHeight * heightRatio;
				newImageWidth = thumbStyle.height * imageRatio;
			}
			// Else if the image ratio is narrower than the container
			else {
				newImageWidth = imageWidth * widthRatio;
				newImageHeight = thumbStyle.width / imageRatio;
			}

			imageStyle.width = newImageWidth;
			imageStyle.height = newImageHeight;
		}

		if (this.props.imageSource) {
			return (
				<div>
					<div className="ope-product-list__thumbnail-wrapper" onClick={this.props.editHandler}>
						<ImagePreview imageSource={this.props.imageSource} item={this.props.item} width="90" height="90"/>
					</div>
					<div className="ope-product-list__item__editLink" onClick={this.props.editHandler}>{_("Edit")}</div>
				</div>
			);
		} else {
			return (
			<div className="ope-product-list__thumbnail-wrapper" >
				<div className="ope-product-list__thumbnail-holder" style={thumbStyle}>
					<OpeLoader style={{paddingLeft: "15px", paddingTop: "10px"}} />
				</div>
			</div>
		);
		}

	},
    componentWillUnmount: function() {
        this.mounted = false;
    }
});

export default ThumbWrapper;
